import { SVGProps } from 'react';

const PlayProfileLarge = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg {...props} width='128' height='128' viewBox='0 0 128 128' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='64' cy='64' r='63' fill='#303036' stroke='#FFDB01' strokeWidth='2' />
      <path
        d='M76.3779 62.4531L53.1681 50.8476C52.9042 50.7164 52.6113 50.6547 52.3169 50.6684C52.0226 50.682 51.7365 50.7704 51.4859 50.9254C51.2353 51.0804 51.0283 51.2967 50.8846 51.554C50.7408 51.8112 50.6651 52.1009 50.6646 52.3955V75.6054C50.665 75.9001 50.7407 76.1898 50.8844 76.4471C51.0281 76.7043 51.2351 76.9207 51.4858 77.0756C51.7365 77.2304 52.0226 77.3188 52.317 77.3322C52.6114 77.3456 52.9044 77.2836 53.1681 77.1522L76.3779 65.5478C76.6653 65.4041 76.9069 65.1832 77.0758 64.9099C77.2446 64.6366 77.3341 64.3217 77.3341 64.0005C77.3341 63.6792 77.2446 63.3643 77.0758 63.091C76.9069 62.8177 76.6653 62.5968 76.3779 62.4531Z'
        fill='#FFDB01'
      />
    </svg>
  );
};

export default PlayProfileLarge;
